import React, { useState, useRef, useCallback, useEffect } from "react";
import { SubmitHandler, FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { useValidation, useTranslation } from "hooks";

import { translations } from "./translations";
import * as S from "./styles";

import { Modal } from "components/shared";
import { Input, Select } from "components/shared/Form";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import {
  ListRegionalState,
  ListRegionalActions,
} from "store/ducks/settings/regional";

interface IFilterProps {
  onFilter: Function;
}

export const FilterRTV: React.FC<IFilterProps> = ({ onFilter }) => {
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors } = useValidation();
  const { getTranslation } = useTranslation(translations);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [cleanShow, setCleanShow] = useState<boolean>(false);
  const dispatch = useDispatch();

  const { loading: listRegionalLoading, data: listRegionalData } = useSelector<
    RootStateOrAny,
    ListRegionalState
  >((state) => state.listRegional);

  const handleSubmit = useCallback<SubmitHandler>(
    async (data) => {
      try {
        onFilter(data);

        setCleanShow(true);
        setModalOpen(false);
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [handleFormErrors, onFilter],
  );

  const handleFilterClean = useCallback(() => {
    if (formRef.current) {
      formRef.current.setFieldValue("cod_rtv", "");
      formRef.current.setFieldValue("rtv_gr", "");
      formRef.current.setFieldValue("general_regional_id", "");

      const clean = {
        cod_rtv: "",
        rtv_gr: "",
        general_regional_id: "",
      };
      onFilter(clean);
    }

    setCleanShow(false);
    setModalOpen(false);
  }, [onFilter]);

  const renderButtonCleanFilter = () => {
    if (cleanShow) {
      return (
        <S.ButtonMini btStyle="dark" onClick={handleFilterClean}>
          {getTranslation("limparFiltro")}
        </S.ButtonMini>
      );
    }
  };

  const getRegional = useCallback(() => {
    dispatch(ListRegionalActions.request({ all: true }));
  }, [dispatch]);

  useEffect(() => {
    getRegional();
  }, [getRegional]);

  return (
    <S.Container>
      <Modal isOpen={modalOpen}>
        <S.ModalContainer>
          <S.Header>
            <S.IconFilter />
            <S.Title>{getTranslation("filtrar")}</S.Title>
          </S.Header>
          <Form ref={formRef} onSubmit={handleSubmit}>
            <S.FormRow>
              <Select
                name="general_regional_id"
                label={getTranslation("regional")}
                options={listRegionalData}
                isLoading={listRegionalLoading}
                isDisabled={listRegionalLoading}
                placeholder={getTranslation("selecione")}
              />
            </S.FormRow>
            <S.FormRow>
              <Input name="cod_rtv" label={getTranslation("rtv")} />
              <Input name="rtv_gr" label={getTranslation("rtv_gr")} />
            </S.FormRow>

            <S.ButtonsWrapper>
              <S.Button
                btStyle="cancel"
                onClick={() => setModalOpen(false)}
                type="button"
              >
                {getTranslation("cancelar")}
              </S.Button>
              <S.Button
                btStyle="danger"
                type="button"
                onClick={handleFilterClean}
              >
                {getTranslation("limparFiltro")}
              </S.Button>
              <S.Button type="submit">{getTranslation("filtrar")}</S.Button>
            </S.ButtonsWrapper>
          </Form>
        </S.ModalContainer>
      </Modal>

      {renderButtonCleanFilter()}
      <S.ButtonFilter onClick={() => setModalOpen(true)}>
        <S.IconFilter />
      </S.ButtonFilter>
    </S.Container>
  );
};
